export default "__VITE_ASSET__Du$aqfB8__"